/* eslint-disable @typescript-eslint/camelcase */
import { batchRequests } from 'apis';
import i18n from 'i18next';
import { messagesRequest } from 'modules/messages/actions';
import { modalClose } from 'modules/modal/actions';
import { push } from 'react-router-redux';
import { all, put, takeLatest } from 'redux-saga/effects';
import { BatchRequest } from 'utils/tsHelpers';
import { getAllUsersRequest } from 'modules/users/actions';
import {
  activeMFAToAllUserFulfilled,
  activeMFAToAllUserRejected,
  activeUserInClientFulfilled,
  activeUserInClientRejected,
  activeUserInClientRequest,
  applyConfigApplicationFulfilled,
  applyConfigApplicationRejected,
  applyConfigApplicationRequest,
  createUserInClientFulfilled,
  createUserInClientRejected,
  createUserInClientRequest,
  disableUserInClientFulfilled,
  disableUserInClientRejected,
  disableUserInClientRequest,
  editApplicationFulfilled,
  editApplicationRejected,
  editApplicationRequest,
  editClientRejected,
  editClientRequest,
  editClientUserFulfilled,
  editClientUserRejected,
  editClientUserRequest,
  editMaintenanceFulfilled,
  editMaintenanceRejected,
  editMaintenanceRequest,
  enableOrDesableRemoteProfileFulfilled,
  enableOrDesableRemoteProfileRejected,
  enableOrDesableRemoteProfileRequest,
  exportUsersCSVRejected,
  exportUsersCSVRequest,
  exportHistorySessionCSVRejected,
  exportHistorySessionCSVRequest,
  getAccessControlFulfilled,
  getAccessControlRejected,
  getAccessControlRequest,
  getAllClientsFulfilled,
  getAllClientsRejected,
  getAllClientsRequest,
  getAllClientsUsersFulfilled,
  getAllClientsUsersRejected,
  getAllClientsUsersRequest,
  saveUrlConnectionRequest,
  saveUrlConnectionFulfilled,
  getApplicationsClientsFulfilled,
  getApplicationsClientsRejected,
  getApplicationsClientsRequest,
  getAvailableApplicationsFulfilled,
  getAvailableApplicationsRejected,
  getAvailableApplicationsRequest,
  getClientByIdFulfilled,
  getClientByIdRejected,
  getClientByIdRequest,
  getHistorySessionsFulfilled,
  getHistorySessionsRejected,
  getHistorySessionsRequest,
  getMaintenanceFulfilled,
  getMaintenanceRejected,
  getMaintenanceRequest,
  getSessionsClientsFulfilled,
  getSessionsClientsRejected,
  getSessionsClientsRequest,
  handleRemoveClientFulfilled,
  handleRemoveClientRejected,
  handleRemoveClientRequest,
  importClientsCSVFulfilled,
  importClientsCSVRejected,
  importClientsCSVRequest,
  importUsersCSVFulfilled,
  importUsersCSVRejected,
  importUsersCSVRequest,
  newApplicationFulfilled,
  newApplicationRejected,
  newApplicationRequest,
  newClientFulfilled,
  newClientRejected,
  newClientRequest,
  newCloneClientFulfilled,
  newCloneClientRejected,
  newCloneClientRequest,
  removeAllSelectedUserFulfilled,
  removeAllSelectedUserRejected,
  removeAllSelectedUserRequest,
  removeClientApplicationFulfilled,
  removeClientApplicationRejected,
  removeClientApplicationRequest,
  removeClientUserFulfilled,
  removeClientUserRejected,
  removeClientUserRequest,
  removeSessionsFulfilled,
  removeSessionsRejected,
  removeSessionsRequest,
  resetMFAUserFulfilled,
  resetMFAUserRejected,
  resetMFAUserRequest,
  sendEmailToResetPasswordFulfilled,
  sendEmailToResetPasswordRejected,
  sendEmailToResetPasswordRequest,
  setAccessControlFulfilled,
  setAccessControlRejected,
  setAccessControlRequest,
  setApplicationFulfilled,
  setApplicationRejected,
  setApplicationRequest,
  testOpenApplicationFulfilled,
  testOpenApplicationRejected,
  testOpenApplicationRequest,
  toggleMFAToAllUserRequest,
  activeCheckedUSerFulfilled,
  activeCheckedUSerRejected,
  activeCheckedUSerRequest,
  inactivateAllUsersFulfilled,
  inactivateAllUsersRejected,
  inactivateAllUsersRequest,
  saveChromeExtensionFulfilled,
  saveChromeExtensionRequest,
  getAllClientsOperatorFulfilled,
  getAllClientsOperatorRejected,
  getAllClientsOperatorRequest,
  activateMultipleApplicationsFulfilled,
  activateMultipleApplicationsRejected,
  activateMultipleApplicationsRequest,
  inactivateMultipleApplicationsFulfilled,
  inactivateMultipleApplicationsRejected,
  inactivateMultipleApplicationsRequest,
  removeMultipleApplicationsFulfilled,
  removeMultipleApplicationsRejected,
  removeMultipleApplicationsRequest,
  getBlockMultipleSessionReportFulfilled,
  getBlockMultipleSessionReportRejected,
  getBlockMultipleSessionReportRequest,
  getConnectionTypeReportFulfilled,
  getConnectionTypeReportRejected,
  getConnectionTypeReportRequest,
  getMFAReportFulfilled,
  getMFAReportRejected,
  getMFAReportRequest,
  getUseProfileReportFulfilled,
  getUseProfileReportRejected,
  getUseProfileReportRequest,
  getClientVirtualizerReportFulfilled,
  getClientVirtualizerReportRejected,
  getClientVirtualizerReportRequest,
  getActivateReportFulfilled,
  getActivateReportRejected,
  getActivateReportRequest,
  getSaltReportFulfilled,
  getSaltReportRejected,
  getSaltReportRequest,
  exportClientSummaryFulfilled,
  exportClientSummaryRejected,
  exportClientSummaryRequest,
  exportUserSummaryFulfilled,
  exportUserSummaryRejected,
  exportUserSummaryRequest,
  removeClientWebApplicationFulfilled,
  removeClientWebApplicationRejected,
  removeClientWebApplicationRequest,
  forceResetPasswordSelectedUsersRequest,
  forceResetPasswordSelectedUsersFulfilled,
  forceResetPasswordSelectedUsersRejected,
  enableUserDeviceValidationBypassRequest,
  enableUserDeviceValidationBypassFulfilled,
  enableUserDeviceValidationBypassRejected,
  disableUserDeviceValidationBypassRequest,
  disableUserDeviceValidationBypassFulfilled,
  disableUserDeviceValidationBypassRejected,
  getDigitalCertificatesFulfilled,
  getDigitalCertificatesRejected,
  getDigitalCertificatesRequest,
  deleteDigitalCertificatesFulfilled,
  deleteDigitalCertificatesRejected,
  deleteDigitalCertificatesRequest,
  createDigitalCertificatesFulfilled,
  createDigitalCertificatesRejected,
  createDigitalCertificatesRequest,
  editDigitalCertificatesFulfilled,
  editDigitalCertificatesRejected,
  editDigitalCertificatesRequest,
} from './actions';
import endpoints, { api } from './endpoints';

function* getAllClientsRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getAllClients(payload),
    });

    return yield put(getAllClientsFulfilled(data));
  } catch (error) {
    return yield put(getAllClientsRejected());
  }
}

function* getAllClientsOperatorRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getAllClientsOperator(payload),
    });

    return yield put(getAllClientsOperatorFulfilled(data));
  } catch (error) {
    return yield put(getAllClientsOperatorRejected());
  }
}

function* getHistorySessionsRequestSaga({ payload }) {
  const { id, query } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getAllHistorySession(id, query),
    });

    return yield put(getHistorySessionsFulfilled(data));
  } catch (error) {
    return yield put(getHistorySessionsRejected());
  }
}

function* exportHistorySessionCSVRequestSaga({ payload }) {
  const { id, query, filename } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.exportHistorySessionCSV(id, query),
    });

    const elm = document.createElement('a');
    elm.href = `data:text/csv;charset=utf-8,${encodeURI(data)}`;
    elm.target = '_blank';
    elm.download = `${filename}.csv`;

    elm.click();

    return yield put(
      messagesRequest({
        type: 'success',
        message: i18n.t('EXPORT_CSV_SUCCESS_KEY'),
      })
    );
  } catch (error) {
    return yield put(exportHistorySessionCSVRejected());
  }
}

function* resetMFAUserRequestSaga({ payload }) {
  const { clientUuid, userUuid, id, query } = payload;
  try {
    yield api.post({
      url: endpoints.resetMFAUser(clientUuid, userUuid),
    });

    return yield all([
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('MFA_RESET_SUCCESS_KEY'),
        })
      ),
      put(resetMFAUserFulfilled()),
      put(getAllClientsUsersRequest({ id, query })),
    ]);
  } catch (error) {
    return yield put(resetMFAUserRejected());
  }
}

function* toggleMFAToAllUserRequestSaga({ payload }) {
  const { id, active } = payload;
  try {
    yield api.post({
      url: endpoints.activeAllUserMFA(id),
      data: {
        activate: active,
      },
    });

    return yield all([
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(
            active
              ? 'ENABLE_MFA_TO_ALL_USERS_SUCCESS_KEY'
              : 'DISABLE_MFA_TO_ALL_USERS_SUCCESS_KEY'
          ),
        })
      ),
      put(activeMFAToAllUserFulfilled(active)),
    ]);
  } catch (error) {
    return yield put(activeMFAToAllUserRejected());
  }
}

function* enableOrDesableRemoteProfileRequestSaga({ payload }) {
  const { userId, id, query, active, profilePath } = payload;
  try {
    yield api.patch({
      url: endpoints.enableOrDisableRemoteProfile(id, userId),
      data: {
        use_profile: active,
        profile_path: active ? profilePath : '',
      },
    });

    return yield all([
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('ENABLE_OR_DISABLE_SUCCESS_KEY', {
            activate: active
              ? i18n.t('ACTIVE_KEY').toLocaleLowerCase()
              : i18n.t('INACTIVATED_KEY').toLocaleLowerCase(),
          }),
        })
      ),
      put(enableOrDesableRemoteProfileFulfilled()),
      put(getAllClientsUsersRequest({ id, query })),
    ]);
  } catch (error) {
    return yield put(enableOrDesableRemoteProfileRejected());
  }
}

function* removeSessionsRequestSaga({ payload }) {
  const { id, query, values } = payload;
  try {
    yield api.post({
      url: endpoints.removeSessions(),
      data: values,
    });

    return yield all([
      put(removeSessionsFulfilled()),
      put(getSessionsClientsRequest({ id, query })),
      put(modalClose()),
    ]);
  } catch (error) {
    return yield put(removeSessionsRejected());
  }
}

function* editMaintenanceRequestSaga({ payload }) {
  const { id, displayValues, changedItems } = payload;

  const batchObject: BatchRequest[] = [];

  if (changedItems.includes('display')) {
    batchObject.push({
      url: endpoints.editMaintenanceDisplayWarning(id),
      method: 'PUT',
      data: displayValues,
    });
  }

  try {
    yield batchRequests(batchObject);

    return yield all([
      put(editMaintenanceFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('CHANGES_SAVED'),
        })
      ),
      put(getClientByIdRequest({ id })),
      put(getMaintenanceRequest({ id })),
    ]);
  } catch (error) {
    return yield put(editMaintenanceRejected());
  }
}

function* getMaintenanceRequestSaga({ payload }) {
  const { id } = payload;
  try {
    const { data } = yield batchRequests([
      {
        url: endpoints.getMaintenanceDisplayWarning(id),
      },
    ]);

    const [displayWarning] = data;

    return yield all([
      put(
        getMaintenanceFulfilled({
          clientsMaintenanceDisplayWarning: displayWarning.data,
        })
      ),
    ]);
  } catch (error) {
    return yield put(getMaintenanceRejected());
  }
}

function* getClientByIdRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getClientById(payload.id),
    });

    return yield put(getClientByIdFulfilled(data));
  } catch (error) {
    return yield put(getClientByIdRejected());
  }
}

function* newClientRequestSaga({ payload }) {
  try {
    const { data } = yield api.post({
      url: endpoints.newClient(),
      data: payload.values,
    });

    return yield all([
      put(newClientFulfilled(data)),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(`CLIENTS_PAGE.${data.message.code.toUpperCase()}`),
        })
      ),
      put(push(`/clients/${data.client_uuid}/configurations`)),
    ]);
  } catch (error) {
    return yield put(newClientRejected());
  }
}

function* editClientRequestSaga({ payload }) {
  const updatedPayload = {
    ...payload,
    licenses: {
      ...payload.licenses,
    },
  };

  if (
    updatedPayload.licenses?.license_group &&
    updatedPayload.licenses.client_license === null
  ) {
    delete updatedPayload.licenses.client_license;
  }
  try {
    yield api.patch({
      url: endpoints.editClient(payload.client_uuid),
      data: updatedPayload,
    });

    return yield all([
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('CLIENTS_PAGE.UPDATED_SUCCESSFULLY_KEY'),
        })
      ),
      put(getClientByIdRequest({ id: payload.client_uuid })),
    ]);
  } catch (error) {
    return yield put(editClientRejected());
  }
}

function* newCloneClientRequestSaga({ payload }) {
  try {
    yield api.post({
      url: endpoints.newCloneClient(payload.clientUuid),
      data: payload.values,
    });

    return yield all([
      put(newCloneClientFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(`CLIENT_CLONE_MESSAGE_KEY`),
        })
      ),
      put(getAllClientsRequest(payload.query)),
    ]);
  } catch (error) {
    return yield put(newCloneClientRejected());
  }
}

function* sendEmailToResetPasswordRequestSaga({ payload }) {
  const { id, userId, copy } = payload;

  try {
    const { status, data } = yield api.post({
      url: endpoints.sendEmailToResetPassword(id, userId),
      data: {
        cc_admin_email: copy,
      },
    });

    if (
      status === 202 &&
      data.message.code === 'fictitious_user_admins_emailed'
    ) {
      return yield all([
        put(sendEmailToResetPasswordFulfilled()),
        put(
          messagesRequest({
            type: 'success',
            message: i18n.t('FICTITIOUS_USER_ADMINS_EMAILED'),
          })
        ),
      ]);
    }

    return yield all([
      put(sendEmailToResetPasswordFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('RESEND_PASSWORD_SUCCESS_KEY'),
        })
      ),
    ]);
  } catch (error) {
    return yield put(sendEmailToResetPasswordRejected());
  }
}

function* createUserInClientRequestSaga({ payload }) {
  const { id, values, query } = payload;
  try {
    yield api.post({
      url: endpoints.createUserInClient(id),
      data: values,
    });

    return yield all([
      put(createUserInClientFulfilled()),
      put(getAllClientsUsersRequest({ id, query })),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('USER_ADDED_SUCCESSFULLY_KEY'),
        })
      ),
      put(modalClose()),
    ]);
  } catch (error) {
    return yield put(createUserInClientRejected());
  }
}

function* disableUserInClientRequestSaga({ payload }) {
  const { userUuid, id, query, isListAllUsers } = payload;
  try {
    yield api.post({
      url: endpoints.inactiveUserInClient(id, userUuid),
    });

    return yield all([
      put(disableUserInClientFulfilled()),
      put(
        isListAllUsers
          ? getAllUsersRequest({ id, ...query })
          : getAllClientsUsersRequest({ id, query })
      ),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('DISABLE_USER_SUCCESS_KEY'),
        })
      ),
    ]);
  } catch (error) {
    return yield put(disableUserInClientRejected());
  }
}

function* activeUserInClientRequestSaga({ payload }) {
  const { userUuid, id, query, isListAllUsers } = payload;
  try {
    yield api.post({
      url: endpoints.activeUserInClient(id, userUuid),
    });

    return yield all([
      put(activeUserInClientFulfilled()),
      put(
        isListAllUsers
          ? getAllUsersRequest({ id, ...query })
          : getAllClientsUsersRequest({ id, query })
      ),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('ACTIVATE_USERS_SUCCESS_KEY'),
        })
      ),
    ]);
  } catch (error) {
    return yield put(activeUserInClientRejected());
  }
}

function* handleRemoveClientRequestSaga({ payload }) {
  try {
    const { data } = yield api.delete({
      url: endpoints.removeClient(payload.clientUuid),
    });

    if (data?.message?.code === 'ad_group_not_deleted') {
      return yield all([
        put(handleRemoveClientRejected()),
        put(
          messagesRequest({
            type: 'error',
            message: i18n.t('ERROR_AD_GROUP_NOT_DELETED'),
          })
        ),
      ]);
    }

    return yield all([
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(`CLIENT_REMOVED_KEY`),
        })
      ),
      put(handleRemoveClientFulfilled(data)),
      put(getAllClientsRequest({ ...payload.query })),
    ]);
  } catch (error) {
    return yield put(handleRemoveClientRejected());
  }
}

function* getSessionsClientsSaga({ payload }) {
  const { id, query } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.clientSession(id, query),
    });

    return yield all([put(getSessionsClientsFulfilled(data))]);
  } catch (error) {
    return yield put(getSessionsClientsRejected());
  }
}

function* getAllClientUsersRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getClientUser(payload.query, payload.id),
    });

    return yield put(getAllClientsUsersFulfilled(data));
  } catch (error) {
    return yield put(getAllClientsUsersRejected());
  }
}

function* getClientApplicationRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getClientApplications(
        payload.query,
        payload.id,
        payload.type
      ),
    });

    return yield put(getApplicationsClientsFulfilled(data));
  } catch (error) {
    return yield put(getApplicationsClientsRejected());
  }
}

function* getAvailableApplicationsRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getAvailableApplications(payload.id, payload.query),
    });

    return yield put(getAvailableApplicationsFulfilled(data));
  } catch (error) {
    return yield put(getAvailableApplicationsRejected());
  }
}

function* applyConfigApplicationRequestSaga({ payload }) {
  try {
    yield api.patch({
      url: endpoints.applyConfigApplication(payload.id, payload.type),
      data: {
        active: payload.active,
      },
    });

    return yield put(applyConfigApplicationFulfilled());
  } catch (error) {
    return yield put(applyConfigApplicationRejected());
  }
}

function* newApplicationRequestSaga({ payload }) {
  try {
    yield api.post({
      url: endpoints.newClientApplication(payload.id, payload.type),
      data: payload.values,
    });

    return yield all([
      put(newApplicationFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('APPLICATIONS_PAGE.APPLICATION_ADDED_SUCCESS_KEY'),
        })
      ),
      put(getApplicationsClientsRequest(payload)),
    ]);
  } catch (error) {
    return yield put(newApplicationRejected);
  }
}

function* editApplicationRequestSaga({ payload }) {
  const { id, type, app_uuid, values: data } = payload;

  try {
    yield api.put({
      url: endpoints.editClientApplication(id, type, app_uuid),
      data,
    });

    return yield all([
      put(editApplicationFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('APPLICATIONS_PAGE.APPLICATION_EDITED_SUCCESS_KEY'),
        })
      ),
      put(getApplicationsClientsRequest(payload)),
    ]);
  } catch (error) {
    return yield put(editApplicationRejected());
  }
}

function* setApplicationRequestSaga({ payload }) {
  const { id, type, app_uuid, values: data } = payload;

  try {
    yield api.patch({
      url: endpoints.editClientApplication(id, type, app_uuid),
      data,
    });

    return yield all([
      put(setApplicationFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('APPLICATIONS_PAGE.APPLICATION_EDITED_SUCCESS_KEY'),
        })
      ),
      put(getApplicationsClientsRequest(payload)),
    ]);
  } catch (error) {
    return yield put(setApplicationRejected());
  }
}

function* removeClientUserRequestSaga({ payload }) {
  const { clientUuid, userUuid, isListAllUsers, query, getUsersFn } = payload;

  try {
    yield api.delete({
      url: endpoints.removeClientUser(clientUuid, userUuid),
    });

    yield all([
      put(removeClientUserFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(`USER_DELETE_SUCCESS_MESSAGE_KEY`),
        })
      ),
    ]);

    if (getUsersFn) {
      return yield getUsersFn();
    }
    if (isListAllUsers) {
      return yield put(getAllUsersRequest(query));
    }
    return yield put(getAllClientsUsersRequest({ id: clientUuid, query }));
  } catch (error) {
    return yield put(removeClientUserRejected());
  }
}

function* removeAllSelectedUserRequestSaga({ payload }) {
  const { query, id, users } = payload;

  try {
    yield api.post({
      url: endpoints.removeAllClient(id),
      data: { users },
    });

    return yield all([
      put(removeAllSelectedUserFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('REMOVE_SELECTED_SUCCESS_KEY'),
        })
      ),
      put(getAllClientsUsersRequest({ id, query })),
    ]);
  } catch (error) {
    return yield put(removeAllSelectedUserRejected());
  }
}

function* activeCheckedUSerRequestSaga({ payload }) {
  const { query, id, users } = payload;

  try {
    yield api.post({
      url: endpoints.activeAllClient(id),
      data: { users },
    });

    return yield all([
      put(activeCheckedUSerFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('ACTIVE_USER_SELECTED_SUCCESS_KEY'),
        })
      ),
      put(getAllClientsUsersRequest({ id, query })),
    ]);
  } catch (error) {
    return yield put(activeCheckedUSerRejected());
  }
}

function* inactivateAllUsersRequestSaga({ payload }) {
  const { query, id, users } = payload;

  try {
    yield api.post({
      url: endpoints.inactivateAllClient(id),
      data: { users },
    });

    return yield all([
      put(inactivateAllUsersFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('INACTIVATE_USERS_SUCCESS_KEY'),
        })
      ),
      put(getAllClientsUsersRequest({ id, query })),
    ]);
  } catch (error) {
    return yield put(inactivateAllUsersRejected());
  }
}

function* editClientUserRequestSaga({ payload }) {
  const { clientUuid, userUuid, values, isListAllUsers, query } = payload;

  try {
    yield api.put({
      url: endpoints.editClientUser(clientUuid, userUuid),
      data: values,
    });

    return yield all([
      put(editClientUserFulfilled()),
      put(
        isListAllUsers
          ? getAllUsersRequest(query)
          : getAllClientsUsersRequest({ id: clientUuid, query })
      ),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(`EDIT_USER_SUCCESS_KEY`),
        })
      ),
    ]);
  } catch (error) {
    return yield put(editClientUserRejected());
  }
}

function* removeClientApplicationRequestSaga({ payload }) {
  const { clientUuid } = payload;
  const isPlatform = !!payload?.appCodes;

  try {
    if (isPlatform) {
      yield api.post({
        url: endpoints.removeClientApplication(clientUuid),
        data: {
          app_codes: payload.appCodes,
        },
      });
    } else {
      yield api.delete({
        url: endpoints.removeClientApplication(clientUuid, payload.appUuid),
      });
    }

    return yield all([
      put(removeClientApplicationFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(`APPLICATIONS_PAGE.REMOVED_APPLICATION_KEY`),
        })
      ),
      put(
        getApplicationsClientsRequest({
          id: clientUuid,
          type: isPlatform ? 'platform' : 'autosky',
        })
      ),
    ]);
  } catch (error) {
    return yield put(removeClientApplicationRejected());
  }
}

function* removeClientWebApplicationRequestSaga({ payload }) {
  const { clientUuid } = payload;

  try {
    yield api.delete({
      url: endpoints.removeClientWebApplication(clientUuid, payload.appUuid),
    });

    return yield all([
      put(removeClientWebApplicationFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(`APPLICATIONS_PAGE.REMOVED_APPLICATION_KEY`),
        })
      ),
      put(
        getApplicationsClientsRequest({
          id: clientUuid,
          type: 'web',
        })
      ),
    ]);
  } catch (error) {
    return yield put(removeClientWebApplicationRejected());
  }
}

function* testOpenApplicationRequestSaga({ payload }) {
  const { id, instanceUuid, values } = payload;

  try {
    const { data } = yield api.post({
      url: endpoints.testOpenApplication(id),
      data: { ...values, instance_uuid: instanceUuid },
    });

    return yield all([
      put(testOpenApplicationFulfilled(data)),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('TEST_CONNECT_SUCCES_KEY'),
        })
      ),
    ]);
  } catch (error) {
    return yield put(testOpenApplicationRejected());
  }
}

function* saveUrlConnectionRequestSaga({ payload }) {
  return yield put(saveUrlConnectionFulfilled(payload));
}

function* saveChromeExtensionRequestSaga({ payload }) {
  return yield put(saveChromeExtensionFulfilled(payload));
}

function* getAccessControlRequestSaga({ payload }) {
  const { id } = payload;

  try {
    const { data } = yield batchRequests([
      {
        url: endpoints.settingsAccessControl(id),
      },
      {
        url: endpoints.allowedIps(id),
      },
      {
        url: endpoints.blockedPeriods(id),
      },
    ]);

    const [settings, allowedIps, blockedPeriods] = data;

    return yield put(
      getAccessControlFulfilled({
        settings: settings.data,
        allowedIps: allowedIps.data,
        blockedPeriods: blockedPeriods.data,
      })
    );
  } catch (error) {
    return yield put(getAccessControlRejected());
  }
}

function* setAccessControlRequestSaga({ payload }) {
  const { id, data } = payload;

  try {
    yield batchRequests([
      {
        url: endpoints.settingsAccessControl(id),
        method: 'PATCH',
        data: data.settings,
      },
      {
        url: endpoints.allowedIps(id),
        method: 'PATCH',
        data: data.allowedIps,
      },
      {
        url: endpoints.blockedPeriods(id),
        method: 'PATCH',
        data: data.blockedPeriods,
      },
    ]);

    return yield all([
      put(setAccessControlFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('CLIENTS_PAGE.ACCESS_CONTROL_UPDATED_KEY'),
        })
      ),
      put(getAccessControlRequest({ id })),
    ]);
  } catch (error) {
    return yield put(setAccessControlRejected());
  }
}

function* exportUsersCSVRequestSaga({ payload }) {
  const { id, filename } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.exportUsersCSV(id),
    });

    const elm = document.createElement('a');
    elm.href = `data:text/csv;charset=utf-8,${encodeURI(data)}`;
    elm.target = '_blank';
    elm.download = `${filename}.csv`;

    elm.click();

    return yield put(
      messagesRequest({
        type: 'success',
        message: i18n.t('EXPORT_CSV_SUCCESS_KEY'),
      })
    );
  } catch (error) {
    return yield put(exportUsersCSVRejected());
  }
}

function* importUsersCSVRequestSaga({ payload }) {
  const { id, values, custom } = payload;

  const formData = new FormData();
  formData.append('csv_file', values.csv_file);
  formData.append('set_password', values.set_password);

  try {
    const { data } = yield api.post({
      url: endpoints.importUsersCSV(id, custom),
      header: {
        'Content-Type': 'multipart/form-data',
      },
      data: formData,
    });

    return yield all([
      put(importUsersCSVFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(data.message.code.toUpperCase()),
        })
      ),
      put(getAllClientsUsersRequest({ id })),
    ]);
  } catch (error) {
    return yield put(importUsersCSVRejected());
  }
}

function* importClientsCSVRequestSaga({ payload }) {
  const { id, values } = payload;

  const formData = new FormData();
  formData.append('csv_file', values.csv_file);

  try {
    const { data } = yield api.post({
      url: endpoints.importClientsCSV(id),
      header: {
        'Content-Type': 'multipart/form-data',
      },
      data: formData,
    });

    return yield all([
      put(importClientsCSVFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(data.message.code.toUpperCase()),
        })
      ),
    ]);
  } catch (error) {
    return yield put(importClientsCSVRejected());
  }
}

function* activateMultipleApplicationsRequestSaga({ payload }) {
  const { id, app_uuids } = payload;

  try {
    yield api.post({
      url: endpoints.activateMultipleApplications(id),
      data: { app_uuids },
    });

    return yield all([
      put(activateMultipleApplicationsFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('APPLICATIONS_ACTIVE_KEY'),
        })
      ),
      put(
        getApplicationsClientsRequest({
          id,
          type: 'autosky',
        })
      ),
    ]);
  } catch (error) {
    return yield put(activateMultipleApplicationsRejected());
  }
}

function* inactivateMultipleApplicationsRequestSaga({ payload }) {
  const { id, app_uuids } = payload;

  try {
    yield api.post({
      url: endpoints.inactivateMultipleApplications(id),
      data: { app_uuids },
    });

    return yield all([
      put(inactivateMultipleApplicationsFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('APPLICATIONS_INACTIVE_KEY'),
        })
      ),
      put(
        getApplicationsClientsRequest({
          id,
          type: 'autosky',
        })
      ),
    ]);
  } catch (error) {
    return yield put(inactivateMultipleApplicationsRejected());
  }
}

function* removeMultipleApplicationsRequestSaga({ payload }) {
  const { id, app_uuids } = payload;
  const isPlatform = !!payload?.appCodes;

  try {
    yield api.post({
      url: endpoints.removeMultipleApplications(id),
      data: { app_uuids },
    });

    return yield all([
      put(removeMultipleApplicationsFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('APPLICATIONS_REMOVED_KEY'),
        })
      ),
      put(
        getApplicationsClientsRequest({
          id,
          type: isPlatform ? 'platform' : 'autosky',
        })
      ),
    ]);
  } catch (error) {
    return yield put(removeMultipleApplicationsRejected());
  }
}

function* getBlockMultipleSessionReportRequestSaga({ payload }) {
  const { filters } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.getBlockMultipleSessionReport(filters),
    });

    return yield put(getBlockMultipleSessionReportFulfilled(data));
  } catch (error) {
    return yield put(getBlockMultipleSessionReportRejected());
  }
}

function* getConnectionTypeReportRequestSaga({ payload }) {
  const { filters } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.getConnectionTypeReport(filters),
    });

    return yield put(getConnectionTypeReportFulfilled(data));
  } catch (error) {
    return yield put(getConnectionTypeReportRejected());
  }
}

function* getMFAReportRequestSaga({ payload }) {
  const { filters } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getMFAReport(filters),
    });

    return yield put(getMFAReportFulfilled(data));
  } catch (error) {
    return yield put(getMFAReportRejected());
  }
}

function* getUseProfileReportRequestSaga({ payload }) {
  const { filters } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getUseProfileReport(filters),
    });

    return yield put(getUseProfileReportFulfilled(data));
  } catch (error) {
    return yield put(getUseProfileReportRejected());
  }
}

function* getClientVirtualizerReportRequestSaga({ payload }) {
  const { filters } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getClientVirtualizerReport(filters),
    });

    return yield put(getClientVirtualizerReportFulfilled(data));
  } catch (error) {
    return yield put(getClientVirtualizerReportRejected());
  }
}

function* getActivateReportRequestSaga({ payload }) {
  const { filtersDashboard } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getActivateReport(filtersDashboard),
    });

    return yield put(getActivateReportFulfilled(data));
  } catch (error) {
    return yield put(getActivateReportRejected());
  }
}

function* getSaltReportRequestSaga({ payload }) {
  const { filtersDashboard } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getSaltReport(filtersDashboard),
    });

    return yield put(getSaltReportFulfilled(data));
  } catch (error) {
    return yield put(getSaltReportRejected());
  }
}

function* exportClientSummaryRequestSaga({ payload }) {
  const { query } = payload;

  query.language = i18n.language || 'pt-BR';
  try {
    const { data } = yield api.get({
      url: endpoints.exportClientSummary(query),
    });

    const elm = document.createElement('a');
    elm.href = `data:text/csv;charset=utf-8,${encodeURIComponent(data)}`;
    elm.target = '_blank';
    elm.download = `${i18n.t('CLIENTS_KEY')}-${new Date().toLocaleString(
      'pt-BR',
      {
        hour12: false,
      }
    )}-summary.csv`;

    elm.click();

    return yield all([
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('EXPORT_CSV_SUCCESS_KEY'),
        })
      ),
      put(exportClientSummaryFulfilled(data)),
    ]);
  } catch (error) {
    return yield put(exportClientSummaryRejected());
  }
}

function* exportUserSummaryRequestSaga({ payload }) {
  const { query } = payload;

  query.language = i18n.language || 'pt-BR';
  try {
    const { data } = yield api.get({
      url: endpoints.exportUserSummary(query),
    });

    const elm = document.createElement('a');
    elm.href = `data:text/csv;charset=utf-8,${encodeURIComponent(data)}`;
    elm.target = '_blank';
    elm.download = `${i18n.t('USERS_KEY')}-${new Date().toLocaleString(
      'pt-BR',
      {
        hour12: false,
      }
    )}-summary.csv`;

    elm.click();

    return yield all([
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('EXPORT_CSV_SUCCESS_KEY'),
        })
      ),
      put(exportUserSummaryFulfilled(data)),
    ]);
  } catch (error) {
    return yield put(exportUserSummaryRejected());
  }
}

function* forceResetPasswordSelectedUsersRequestSaga({ payload }) {
  const { id, query, userUuids, clientUuid, forceReset } = payload;

  try {
    yield api.patch({
      url: (forceReset
        ? endpoints.activateForceResetPasswordSelectedUsers
        : endpoints.inactivateForceResetPasswordSelectedUsers)(clientUuid),
      data: { users: userUuids },
    });

    return yield all([
      put(forceResetPasswordSelectedUsersFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(
            `${
              forceReset ? 'ACTIVE' : 'INACTIVE'
            }_FORCE_RESET_PASSWORD_SUCCESS_KEY`
          ),
        })
      ),
      put(getAllClientsUsersRequest({ id, query })),
    ]);
  } catch (error) {
    return yield put(forceResetPasswordSelectedUsersRejected());
  }
}

function* enableUserDeviceValidationBypassRequestSaga({ payload }) {
  const { getClientUsersFn, values, clientUuid, userUuid } = payload;

  try {
    yield api.post({
      url: endpoints.enableUserDeviceValidationBypass(clientUuid, userUuid),
      data: values,
    });

    return yield all([
      put(enableUserDeviceValidationBypassFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('ENABLE_DEVICE_VALIDATION_BYPASS_SUCCESS_KEY'),
        })
      ),
      getClientUsersFn(),
    ]);
  } catch (error) {
    return yield put(enableUserDeviceValidationBypassRejected());
  }
}

function* disableUserDeviceValidationBypassRequestSaga({ payload }) {
  const { getClientUsersFn, clientUuid, userUuid } = payload;

  try {
    yield api.post({
      url: endpoints.disableUserDeviceValidationBypass(clientUuid, userUuid),
    });

    return yield all([
      put(disableUserDeviceValidationBypassFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('DISABLE_DEVICE_VALIDATION_BYPASS_SUCCESS_KEY'),
        })
      ),
      getClientUsersFn(),
    ]);
  } catch (error) {
    return yield put(disableUserDeviceValidationBypassRejected());
  }
}

function* getDigitalCertificatesRequestSaga({ payload }) {
  const { clientUuid, query } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getDigitalCertificates(clientUuid, query),
    });

    return yield put(getDigitalCertificatesFulfilled(data));
  } catch (error) {
    return yield put(getDigitalCertificatesRejected());
  }
}

function* deleteDigitalCertificatesRequestSaga({ payload }) {
  const { clientUuid, certificateUuid, query } = payload;

  try {
    yield api.delete({
      url: endpoints.deleteDigitalCertificates(clientUuid, certificateUuid),
    });

    return yield all([
      put(deleteDigitalCertificatesFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(`DIGITAL_CERTIFICATE_DELETED_SUCCESSFULLY_KEY`),
        })
      ),
      put(
        getDigitalCertificatesRequest({
          clientUuid,
          query,
        })
      ),
    ]);
  } catch (error) {
    return yield put(deleteDigitalCertificatesRejected());
  }
}

function* createDigitalCertificatesRequestSaga({ payload }) {
  const { clientUuid, query, data } = payload;

  try {
    yield api.post({
      url: endpoints.createDigitalCertificates(clientUuid),
      data,
    });

    return yield all([
      put(createDigitalCertificatesFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(`DIGITAL_CERTIFICATE_CREATED_SUCCESSFULLY_KEY`),
        })
      ),
      put(
        getDigitalCertificatesRequest({
          clientUuid,
          query,
        })
      ),
    ]);
  } catch (error) {
    return yield put(createDigitalCertificatesRejected());
  }
}

function* editDigitalCertificatesRequestSaga({ payload }) {
  const { clientUuid, certificateUuid, query, data } = payload;

  try {
    yield api.patch({
      url: endpoints.editDigitalCertificates(clientUuid, certificateUuid),
      data,
    });

    return yield all([
      put(editDigitalCertificatesFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(`DIGITAL_CERTIFICATE_EDITED_SUCCESSFULLY_KEY`),
        })
      ),
      put(
        getDigitalCertificatesRequest({
          clientUuid,
          query,
        })
      ),
    ]);
  } catch (error) {
    return yield put(editDigitalCertificatesRejected());
  }
}

export default all([
  takeLatest(getAllClientsRequest, getAllClientsRequestSaga),
  takeLatest(getSessionsClientsRequest, getSessionsClientsSaga),
  takeLatest(getAllClientsUsersRequest, getAllClientUsersRequestSaga),
  takeLatest(newApplicationRequest, newApplicationRequestSaga),
  takeLatest(editApplicationRequest, editApplicationRequestSaga),
  takeLatest(setApplicationRequest, setApplicationRequestSaga),
  takeLatest(getApplicationsClientsRequest, getClientApplicationRequestSaga),
  takeLatest(
    getAvailableApplicationsRequest,
    getAvailableApplicationsRequestSaga
  ),
  takeLatest(applyConfigApplicationRequest, applyConfigApplicationRequestSaga),
  takeLatest(handleRemoveClientRequest, handleRemoveClientRequestSaga),
  takeLatest(newClientRequest, newClientRequestSaga),
  takeLatest(getClientByIdRequest, getClientByIdRequestSaga),
  takeLatest(editClientRequest, editClientRequestSaga),
  takeLatest(newCloneClientRequest, newCloneClientRequestSaga),
  takeLatest(removeClientUserRequest, removeClientUserRequestSaga),
  takeLatest(editClientUserRequest, editClientUserRequestSaga),
  takeLatest(
    removeClientApplicationRequest,
    removeClientApplicationRequestSaga
  ),
  takeLatest(removeSessionsRequest, removeSessionsRequestSaga),
  takeLatest(createUserInClientRequest, createUserInClientRequestSaga),
  takeLatest(disableUserInClientRequest, disableUserInClientRequestSaga),

  takeLatest(editMaintenanceRequest, editMaintenanceRequestSaga),
  takeLatest(getMaintenanceRequest, getMaintenanceRequestSaga),

  takeLatest(
    sendEmailToResetPasswordRequest,
    sendEmailToResetPasswordRequestSaga
  ),
  takeLatest(testOpenApplicationRequest, testOpenApplicationRequestSaga),
  takeLatest(activeUserInClientRequest, activeUserInClientRequestSaga),
  takeLatest(getAccessControlRequest, getAccessControlRequestSaga),
  takeLatest(setAccessControlRequest, setAccessControlRequestSaga),
  takeLatest(exportUsersCSVRequest, exportUsersCSVRequestSaga),
  takeLatest(resetMFAUserRequest, resetMFAUserRequestSaga),
  takeLatest(toggleMFAToAllUserRequest, toggleMFAToAllUserRequestSaga),
  takeLatest(getHistorySessionsRequest, getHistorySessionsRequestSaga),
  takeLatest(
    exportHistorySessionCSVRequest,
    exportHistorySessionCSVRequestSaga
  ),
  takeLatest(
    enableOrDesableRemoteProfileRequest,
    enableOrDesableRemoteProfileRequestSaga
  ),
  takeLatest(removeAllSelectedUserRequest, removeAllSelectedUserRequestSaga),
  takeLatest(importUsersCSVRequest, importUsersCSVRequestSaga),
  takeLatest(importClientsCSVRequest, importClientsCSVRequestSaga),
  takeLatest(saveUrlConnectionRequest, saveUrlConnectionRequestSaga),
  takeLatest(activeCheckedUSerRequest, activeCheckedUSerRequestSaga),
  takeLatest(inactivateAllUsersRequest, inactivateAllUsersRequestSaga),
  takeLatest(saveChromeExtensionRequest, saveChromeExtensionRequestSaga),
  takeLatest(getAllClientsOperatorRequest, getAllClientsOperatorRequestSaga),
  takeLatest(
    activateMultipleApplicationsRequest,
    activateMultipleApplicationsRequestSaga
  ),
  takeLatest(
    inactivateMultipleApplicationsRequest,
    inactivateMultipleApplicationsRequestSaga
  ),
  takeLatest(
    removeMultipleApplicationsRequest,
    removeMultipleApplicationsRequestSaga
  ),

  takeLatest(
    getBlockMultipleSessionReportRequest,
    getBlockMultipleSessionReportRequestSaga
  ),
  takeLatest(
    getConnectionTypeReportRequest,
    getConnectionTypeReportRequestSaga
  ),
  takeLatest(getMFAReportRequest, getMFAReportRequestSaga),
  takeLatest(getUseProfileReportRequest, getUseProfileReportRequestSaga),
  takeLatest(
    getClientVirtualizerReportRequest,
    getClientVirtualizerReportRequestSaga
  ),
  takeLatest(getActivateReportRequest, getActivateReportRequestSaga),
  takeLatest(getSaltReportRequest, getSaltReportRequestSaga),
  takeLatest(exportClientSummaryRequest, exportClientSummaryRequestSaga),
  takeLatest(exportUserSummaryRequest, exportUserSummaryRequestSaga),
  takeLatest(
    removeClientWebApplicationRequest,
    removeClientWebApplicationRequestSaga
  ),
  takeLatest(
    forceResetPasswordSelectedUsersRequest,
    forceResetPasswordSelectedUsersRequestSaga
  ),

  takeLatest(
    enableUserDeviceValidationBypassRequest,
    enableUserDeviceValidationBypassRequestSaga
  ),
  takeLatest(
    disableUserDeviceValidationBypassRequest,
    disableUserDeviceValidationBypassRequestSaga
  ),
  takeLatest(getDigitalCertificatesRequest, getDigitalCertificatesRequestSaga),
  takeLatest(
    deleteDigitalCertificatesRequest,
    deleteDigitalCertificatesRequestSaga
  ),
  takeLatest(
    createDigitalCertificatesRequest,
    createDigitalCertificatesRequestSaga
  ),
  takeLatest(
    editDigitalCertificatesRequest,
    editDigitalCertificatesRequestSaga
  ),
]);
